<template>
    <div class="events">
        <div class="content">
            <div class="header">
                <div class="header-right">
                    <span>{{ $t('word.unprocessed') }}<b>{{ unread }}</b>{{ $t('word.item') }}/{{ $t('word.total') }}{{ pager.total }}{{ $t('word.item') }}</span>
                </div>
            </div>
            <div class="list">
                <div v-for="item in absenceList" class="listItem">
                    <div class="item-first-row"><span>{{ $t('word.offWorker') }}：<b class="user">{{ item.originateUserName }}</b></span><span>{{ $t('word.suspendWork') }}：<b class="book">《{{ item.requirementName }}》</b></span></div>
                    <div class="item-second-row"><span>{{ $t('word.suspendTime') }}：{{ $t('word.from') }} <b>{{ getFormatDate(item.startTime) }}</b> {{ $t('word.to') }} <b>{{ getFormatDate(item.endTime)}}</b> {{ $tc('word.total') }} <b>{{ getDiffDays(item.startTime, item.endTime) }}</b> {{ $t('word.day') }}</span>
                        <el-button type="primary" size="small" @click="handleAbsence(item.id)"><span v-if="item.status===1">{{ $t('comb.handle') }}</span><span v-else="item.status!==1">{{ $t('word.check') }}</span></el-button></div>
                </div>
                <el-pagination class="pagination" layout="prev, pager, next" :total="pager.total" size="pager.size"
                               :current-page="pager.currentPage" @current-change="pageChange">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="multiAuditOnLeave" custom-class="detailDialog" v-model="dialogVisible" size="small">
            <span>{{ $t('word.offWorker') }}：{{ detail.anchor }}</span>
            <span>{{ $t('word.suspendWork') }}： {{ detail.workName }}</span>
            <span>{{ $t('word.suspendTime') }}： {{ $t('word.from') }}{{ detail.startDate }}{{ $t('word.to') }}{{ detail.endDate }} {{ $t('word.total') }}{{ detail.duration }}{{ $tc('word.day') }}</span>
            <span>{{ $t('comb.additionalRemarks') }}： {{ detail.description }}</span>
            <span>{{ $t('comb.commitTime') }}： {{ detail.commitTime }}</span>
            <span>{{ $t('word.status') }}：{{ detail.statusLabel}}</span>
            <div v-if="detail.status===1" class="buttons">
                <el-button type="primary" @click="agree">{{ $t('word.agree') }}</el-button>
                <el-button type="warning" @click="disagree">{{ $t('word.refuse') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import axios from 'axios';
    import moment from 'moment';
    export default {
        data () {
            return {
                pager: {
                    total: 0,
                    size: 10,
                    currentPage: 1
                },
                unread: 0,
                absenceList: [],
                dialogVisible: false,
                detail: {
                    id: '',
                    anchor: '',
                    workName: '',
                    startDate: '',
                    endDate: '',
                    duration: '',
                    description: '',
                    commitTime: '',
                    status: 0,
                    statusLabel: ''
                }
            }
        },
        beforeMount () {
            this.getInit();
        },
        methods: {
            getInit () {
                this.getUnHandlerEventCount();
                this.getAbsenceListByPage(1);
            },
            handleAbsence(eventId) {
                const that = this;
                axios.get(`/api/event/vacation/${eventId}/detail`).then(res => {
                    if (res.data.code === 200) {
                        const data = res.data.data;
                        that.detail.id = data.id;
                        that.detail.anchor = data.originateUserName;
                        that.detail.workName = data.requirementName;
                        that.detail.startDate = that.getFormatDate(data.startTime);
                        that.detail.endDate = that.getFormatDate(data.endTime);
                        that.detail.duration = that.getDiffDays(data.startTime, data.endTime);
                        that.detail.description = data.description;
                        that.detail.commitTime = that.getFormatDate(data.createTime);
                        that.detail.status = data.status;
                        that.detail.statusLabel = data.statusLabel;
                        that.dialogVisible = true;
                    }
                });
            },
            pageChange (pageNumber) {
                this.getAbsenceListByPage(pageNumber);
            },
            getAbsenceListByPage (pageNumber) {
                const that = this;
                axios.get(`/api/event/vacation/list/${pageNumber}`).then(res => {
                    if (res.data.code === 200) {
                        that.absenceList = res.data.data.items;
                        that.pager.total = res.data.data.total;
                        that.pager.size = res.data.data.pageSize;
                        that.pager.currentPage = res.data.data.pageNum;
                    }
                });
            },
            getUnHandlerEventCount () {
                const that = this;
                axios.get(`/api/event/vacation/count`).then(res => {
                    if (res.data.code === 200) {
                        that.unread = res.data.data.unaudited;
                        this.$store.commit('UPDATE_UNHANDLE_EVENT', that.unread);
                    }
                });
            },
            getFormatDate (val) {
                return moment(val).format('YYYY-MM-DD');
            },
            getDiffDays(startDate, endDate) {
                return moment(endDate).diff(moment(startDate), 'days')+1;
            },
            agree () {
                axios.post(`/api/event/vacation/${this.detail.id}/accept`).then(res => {
                    if (res.data.code === 200) {
                        this.getUnHandlerEventCount();
                        this.getAbsenceListByPage(this.pager.currentPage);
                        this.dialogVisible = false;
                    }
                });
            },
            disagree () {
                axios.post(`/api/event/vacation/${this.detail.id}/reject`).then(res => {
                    if (res.data.code === 200) {
                        this.getUnHandlerEventCount();
                        this.getAbsenceListByPage(this.pager.currentPage);
                        this.dialogVisible = false;
                    }
                });
            }
        },
        computed: {
            multiAuditOnLeave() {
                return this.$i18n.t('comb.auditOnLeave');
            }
        }
    }
</script>

<style lang="sass" scoped>
    @import "../../../sass/copyright/center/events.scss";
</style>



// WEBPACK FOOTER //
// Events.vue?6bc1eabe